<template>
  <div class="aansluitingen pt-12">
    <v-container fluid class="grey darken-3 recolor" py-0 :class="[$vuetify.breakpoint.mdAndUp ? '' : '']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? 'px-8' : 'px-0 pb-0']">
        <v-layout
          align-center
          fill-height
          row 
          wrap
          :class="[$vuetify.breakpoint.mdAndUp ? 'pt-12 mt-8' : '']"
        >
          <v-flex xs12 class="d-flex h-100">
            <v-container fluid :class="[$vuetify.breakpoint.mdAndUp ? '' : 'pb-2']">
              <v-layout row wrap align-stretch :class="[$vuetify.breakpoint.mdAndUp ? 'py-6' : 'pt-6 pb-0']">
                <v-flex  xs12 md6  ma-0 class="" :class="[$vuetify.breakpoint.mdAndUp ? 'pr-8 ' : 'mb-10']">
                  <v-card height="100%" color="grey darken-4 recolor" class="elevation-0" :class="[$vuetify.breakpoint.mdAndDown ? 'px-4 py-6' : 'pl-5 pr-8 py-8', $vuetify.breakpoint.smAndDown ? '' : 'bor-white']">
                    <v-container fluid py-0 ma-0 fill-height>
                      <v-layout row wrap  fill-height >
                        <v-flex xs12 lg5 xl6 :class="[$vuetify.breakpoint.mdAndUp ? 'px-5' : 'pb-2']">
                          <v-card :height="$vuetify.breakpoint.lgAndDown ? '250' : '350'" class="elevation-0 tile head-graph pa-0" color="transparent" style="margin-top: -34px !important;" :class="[$vuetify.breakpoint.mdAndDown ? '' : '']">
                            <pie-chart :data="connectionStates"></pie-chart>
                          </v-card>
                        </v-flex>
                        <v-flex xs12 lg7 xl6 :class="[$vuetify.breakpoint.mdAndDown ? '' : 'pl-2']">
                          <div v-if="loadingConnectionStates"><span class="d-block mt-2"><v-icon class="font-30">fas fa-spinner fa-spin</v-icon><span class="primary--text font-weight-bold mx-2">De gegevens worden opgehaald</span></span></div>
                          <div class="d-flex align-content-space-between flex-wrap fill-height" v-if="!loadingConnectionStates">
                            <v-container fluid py-0 mb-auto>
                              <v-layout row wrap py-0 :class="[$vuetify.breakpoint.mdAndDown ? 'pt-4 text-center' : '']">
                                <v-flex xs12>
                                  <span class="headline">{{ formatNumber(totalConnections) }} aansluitingen</span>
                                </v-flex>
                                <v-flex xs12 class="mb-6"><span>{{ formatNumber(okConnections) }} aansluitingen zijn in orde</span></v-flex>
                              </v-layout>
                            </v-container> 
                            <v-container fluid py-0>
                              <v-layout row wrap>
                                <v-flex xs12 class="bot-bor-white top-bor-white py-2" v-for="(item, i) in connectionStatesList" :key="i">
                                  <v-container fluid py-0>
                                    <v-layout row wrap align-center fill-height>
                                      <a class="w-100 d-flex stat-link" @click="filter({ state:item.states }, true)">
                                        <span>
                                          {{ formatNumber(item.amount) }} aansluitingen {{ item.label }}
                                        </span>
                                        <v-icon class="ml-auto mr-1 pl-2" >fas fa-chevron-right</v-icon>
                                      </a>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
                <v-flex  xs12 md6  ma-0 class="" :class="[$vuetify.breakpoint.mdAndUp ? ' ' : 'mb-8']">
                  <v-card height="100%" color="grey darken-4 recolor" class="elevation-0" :class="[$vuetify.breakpoint.mdAndDown ? 'px-4 py-6' : 'pl-5 pr-8 py-8', $vuetify.breakpoint.smAndDown ? '' : 'bor-white']">
                    <v-container fluid py-0 ma-0 fill-height>
                      <v-layout row wrap  fill-height >
                        <v-flex xs12 lg5 xl6 :class="[$vuetify.breakpoint.mdAndUp ? 'px-5' : 'pb-2']">
                          <v-card :height="$vuetify.breakpoint.lgAndDown ? '250' : '350'" class="elevation-0 tile head-graph pa-0" color="transparent" style="margin-top: -34px !important;" :class="[$vuetify.breakpoint.mdAndDown ? '' : '']">
                            <pie-chart :data="mandateStates"></pie-chart>
                          </v-card>
                        </v-flex>
                        <v-flex xs12 lg7 xl6 :class="[$vuetify.breakpoint.mdAndDown ? '' : 'pl-2']">
                          <div v-if="loadingMandareStates"><span class="d-block mt-2"><v-icon class="font-30">fas fa-spinner fa-spin</v-icon><span class="primary--text font-weight-bold mx-2">De gegevens worden opgehaald</span></span></div>
                          <div class="d-flex align-content-space-between flex-wrap fill-height" v-if="!loadingMandareStates">
                            <v-container fluid py-0 mb-auto>
                              <v-layout row wrap py-0 :class="[$vuetify.breakpoint.mdAndDown ? 'pt-4 text-center' : '']">
                                <v-flex xs12>
                                  <span class="headline">{{ formatNumber(totalMandates) }} mandaten</span>
                                </v-flex>
                                <v-flex xs12 class="mb-6"><span>{{ formatNumber(okMandates) }} mandaten zijn up to date</span></v-flex>
                              </v-layout>
                            </v-container> 
                            <v-container fluid py-0>
                              <v-layout row wrap>
                                <v-flex xs12 class="bot-bor-white top-bor-white py-2" v-for="(item, i) in mandateStatesList" :key="i">
                                  <v-container fluid py-0>
                                    <v-layout row wrap align-center fill-height>
                                      <a class="w-100 d-flex stat-link"  @click="filter(item.filter, true)" v-if="item.filter != undefined">
                                        <span>
                                          {{ formatNumber(item.amount) }} mandaten {{ item.label }}
                                        </span>
                                        <v-icon class="ml-auto mr-1 pl-2">fas fa-chevron-right</v-icon>
                                      </a>
                                      <a class="w-100 d-flex stat-link" v-if="item.filter == undefined">
                                          {{ formatNumber(item.amount) }} mandaten {{ item.label }}
                                      </a>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <v-container fluid black :class="[$vuetify.breakpoint.mdAndUp ? 'py-12' : 'px-0']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-0']">
        <v-layout row wrap :class="[$vuetify.breakpoint.mdAndUp ? 'px-4' : 'px-3']">
          <v-flex xs12>
            <s-card >
              <v-card-title class="px-0 white--text">
                {{ pageContent.pageSub2 }}
                <v-btn @click="connectionsFilter = true" small icon class="ml-2"> <v-icon>filter_list</v-icon> </v-btn>
              </v-card-title>
              <v-data-table dark
                :headers="headers"
                :items="connections"
                :server-items-length="connectionsTotal"
                :options.sync="connectionsOptions"
                :items-per-page="25"
                :loading="loadingConnections"
                class="elevation-0 big-headers mt-4 transparent dark-table p4-table"
                :footer-props="{ itemsPerPageOptions: [25,50,75,100], itemsPerPageText: 'Rijen per pagina' }"
                :class="[$vuetify.breakpoint.smAndUp ? 'white-borders' : 'mobile-table']"
                dense
                loading-text="laden..."
                no-results-text="geen aansluitingen beschikbaar"
                no-data-text="geen aansluitingen beschikbaar"
              >
                <template v-slot:item.grid="{ item }">
                  <span class="text-no-wrap w-100 d-block" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']">
                    <a class="white--text no-dec d-flex" @click="selectdOperator(item)">
                        <span>{{ item.grid.name }}</span>
                        <v-spacer></v-spacer>
                        <v-icon class=" small-icon" v-if="item.grid.name != ''">fas fa-chevron-right</v-icon>
                    </a>
                  </span>
                </template>
                <template v-slot:item.state="{ item }">
                  <span class="text-no-wrap d-flex">
                    <span class="white--text no-dec mr-2"> 

                      <div class="status-indicator mr-1">
                        <div class="status-filler" :class="[item.state === null ? 'green' : (item.state === 'in deployment' || item.state === 'afwachting' ? 'orange' : 'red')]"></div>
                      </div>
                      {{ item.state }}</span>
                  </span>
                </template>
                <template v-slot:item.state_date="{ item }">
                  <span class="text-no-wrap w-100 d-block" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']">
                    <a class="white--text no-dec d-flex" @click="toRequests({ean:item.ean})">
                      <span>{{ item.state_date == null ? '' : toShortDate(item.state_date) }}</span>
                      <v-spacer></v-spacer>
                      <v-icon class="ml-auto small-icon" >fas fa-chevron-right</v-icon>
                    </a>
                  </span>
                </template>
                <template v-slot:item.data_state="{ item }">
                  <span class="text-no-wrap d-flex">
                      <div class="status-indicator mr-1">
                        <div class="status-filler" :class="[item.data_state === 'ok' ? 'green' : '', item.data_state === 'warning' ? 'orange' : '', item.data_state === 'error' ? 'red' : '']"></div>
                      </div>
                  </span>
                </template>
                <template v-slot:item.end="{ item }">
                  <span class="text-no-wrap d-flex">
                    {{ item.end == null ? '' : toShortDate(item.end) }}
                  </span>
                </template>
              </v-data-table>
            </s-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
   <filters title="Filter aansluitingen" :open.sync="connectionsFilter" :options="connectionFilterOption" :values="connectionsOptions.filters" @filter="filter"></filters>
   <operator :operator="selectedOperator" v-bind:dialog.sync="operatorDialog"></operator>
  </div>
</template>

<script>

import PieChart from '@/components/PieChart';
import Operator from '@/components/Operator';
import Filters from '@/components/Filters';

export default {

  name: 'aansluitingen',
  components: {PieChart, Operator, Filters},
  data() {
    return {
      connectionStates:[],
      connectionStatesList:[],
      loadingConnectionStates:false,
      totalConnections:0,
      okConnections:0,
      mandateStates:{},
      mandateStatesList:{},
      totalMandates:0,
      okMandates:0,
      selectedOperator:{},
      operatorDialog: false,
      headers: [
        //{ text: 'Klant', value: 'klant', align: 'left',},
        { text: 'Postcode', value: 'postal' },
        { text: 'Huisnr', value: 'number' },
        { text: 'Naam', value: 'name' },
        { text: 'EAN', value: 'ean' },
        { text: 'Type', value: 'type' },
        { text: 'Netbeheerder', value: 'grid'},
        { text: 'Meter status', value: 'state' },
        { text: 'Datum', value: 'state_date' },
        //{ text: 'Eind datum', value: 'end' },
        { text: 'Data status', value: 'data_state' },
      ],
      connectionsFilter:false,
      connectionFilterOption: {
        postal:{type:'text', label:'Postcode', placeholder:'1234AB'},
        number:{type:'text', label:'Huisnummer', placeholder:'1'},
        name:{type:'text', label:'Naam', placeholder:'piet'},
        ean:{type:'text', label:'EAN', placeholder:'123456789012345678'},
        type:{type:'select', label:'Type', options:[{ text: 'allemaal', value: null}, { text: 'elektriciteit', value: 1}, { text: 'gas', value: 3}, { text: 'teruglevering', value: 2}]},
        grid:{type:'select', label:'Netbeheerder', options:this.$store.state.operators},
        state:{type:'select', label:'Meter status', options:[
            { text: 'allemaal', value: null}, 
            { text: 'in orde', value: 'ok'}, 
            { text: 'geen slimme meter', value: 'meter'}, 
            { text: 'afwachting', value: 'new'}, 
            { text: 'in deployment', value: 'deployment'}, 
            { text: 'meter in storing', value: 'mallfunction'}, 
            { text: 'kan geen verzoeken verwerken', value: 'handle'}, 
            { text: 'netbeheerder onbekend', value: 'operator'}, 
            { text: 'bericht kan niet afgeleverd worden', value: 'deliver'}, 
            { text: 'meter staat uit', value: 'off'}, 
            { text: 'niet op afstand uitleesbaar', value: 'readable'}, 
            { text: 'contractant is gewijzigd', value: 'moved'}, 
            { text: 'Mandaat is verlopen', value: 'ended'}, 
            { text: 'Mandaat verloopt binnen 7 dagen', value: 'soon'}, 
          ]
        },
        //end:{ type:'date', label:'eind datum' },
        data_state:{type:'select', label:'Data status', options:[{ text: 'allemaal', value: null}, { text: 'goed', value: 'ok'}, { text: 'matig', value: 'orange'}, { text: 'slecht', value: 'red'}]},
      },
      connectionsTotal:0,
      connections: [ ],
      snackbar: false,
      text: 'Succesvol opgeslagen',
      color: 'primary',
      icon: 'check_circle',
      timeout: 3000,
      connectionAmount:0,
      loadingConnections: false,
      search:[],
      pageContent: {
        pageTitle: 'Aansluiting overzicht',
        pageSub1: 'Alle aansluitingen',
        pageSub2: 'Aansluitingen',
      },
	    companies:[],
      operators: [ ],
      types: [ { text:'allemaal', value:null }, { text:'elektriciteit', value:1 }, { text:'gas', value:3 }, { text:'teruglevering', value:2 } ],
      states: [ { text:'allemaal', value:null }, { text:'actief', value:'actief' }, { text:'contract wijziging', value:'contract wijziging' }, { text:'inactief', value:'inactief' } ],
    };
  },
  computed: {
    connectionsOptions: {
        get: function()
        {
          return this.$store.state.connectionsOptions;
        },
        set: function(value)
        {
          this.$store.state.connectionsOptions = value;
        }
    },
    permissions : {
      get() {
        return this.$store.getters.permissions;
      }
    }
  },
  mounted()
  {
    this.loadConnectionStates();
    this.loadMandateStates();
  },
  watch:
  {
    connectionsOptions: {
      deep:true,
          handler (newState, old) {
          this.loadConnections();
      }
    }
	},
  methods:
  {
    loadConnections(context, data)
    {
      this.loadingConnections = true;
      this.$store.dispatch('loadConnections', this.connectionsOptions).then
      ((data) => {
        this.connectionsTotal = data.totalRecords;
        this.connections = data.data;
        this.loadingConnections = false;
      });
    },
    loadConnectionStates()
    {
      this.loadingConnectionStates = true;
      this.$store.dispatch('loadConnectionState', {}).then
      ((data) => {
        let errors = {amount:0, state:'error'};
        let ok = {amount:0, state:'in orde'};
        this.okConnections = this.totalConnections = 0;
        this.connectionStatesList = [];
        for(var i in data.data)
        {
          let state = data.data[i];
          this.totalConnections += state.amount;
          if(i == 'ok')
          {
            this.okConnections = state.amount;
            ok.amount = state.amount;
          }
          else
          {
            this.connectionStatesList.push(state);
            errors.amount = state.amount;
          }
        }
        this.connectionStates = [errors, ok];
        this.loadingConnectionStates = false;
      });
    },
    loadMandateStates()
    {
      this.loadingMandareStates = true;
      this.$store.dispatch('loadMandateState', {}).then
      ((data) => {
        this.mandateStatesList = [];
        this.loadingMandareStates = false;
        this.okMandates = this.totalMandates = 0;
        let errors = {amount:0, state:'beindingd'};
        let warning = {amount:0, state:'binnenkort afgelopen'};
        let ok = {amount:0, state:'in orde'};
        for(var i in data.data)
        {
          let state = data.data[i];
          this.totalMandates += state.amount;
          if(i == 'ok')
          {
            this.okMandates = state.amount;
            ok.amount += state.amount;
          }
          else if(i == 'soon')
          {
            warning.amount += state.amount;
            this.mandateStatesList.push(state);
          }
          else
          {
            errors.amount += state.amount;
            this.mandateStatesList.push(state);
          }
        }
        this.mandateStates = [errors, warning, ok];
      });
    },
    checkHeaders()
    {
      if(this.may(this.permissions, 'companies', this.$store.getters.rights.RIGHT_READALL))
      {
        let self = this;
        if(this.headers[0].text != 'bedrijf')
        {
          this.headers.splice(0, 0, { text: 'bedrijf', value: 'company' });
        }
      }
      else if(this.headers[0].text == 'bedrijf')
      {
        this.headers.shift();
      }
    },
    filter(filters, scrollTo)
    {
      let temp = JSON.parse(JSON.stringify(this.connectionsOptions));
      temp.filters = filters;
      temp.page = 1;
      this.connectionsOptions = JSON.parse(JSON.stringify(temp));
      if(scrollTo === true)
      {
        this.$vuetify.goTo('table');
      }
    },
    selectdOperator(operator)
    {
      this.selectedOperator = operator.grid;
      this.operatorDialog = true;
    },
  },
  created()
  {
    if(this.$store.getters.auth === false){
      this.$router.push({name: 'authentication'});
    }
    this.checkHeaders();
    
    if(this.may(this.permissions, 'companies', this.$store.getters.rights.RIGHT_READALL))
    {
      this.$store.dispatch('LoadCompanyList').then
      ((data) => {
        data.companies.push({text:'allemaal', value:null});
        this.companies = data.companies;
      });
    }
  }
};
</script>
